import { getSharedEnv } from '../../../shared/lib/env'

const contactAddress = getSharedEnv('urls.contactUs')

export default {
  '404': {
    body: `Looks like there is nothing here`,
    title: 'Uh Oh!',
    linkText: 'Back to the homepage',
    link: '/',
  },
  '500': {
    body: `We are experiencing issues at this time.
    Please try refreshing the page, or if you require additional support please **[contact us](${contactAddress})**.`,
    title: 'Something went wrong',
    linkText: 'Back to the homepage',
    link: '/',
  },
  '400': {
    body: `Please enable browser cookies to browse and shop on Westfield Direct`,
    title: 'Uh Oh!',
    linkText: 'Back to the homepage',
    link: '/',
  },
  default: {
    body: `Sorry, we're having trouble fetching that request.
  Please try again later.`,
    title: 'Uh Oh!',
    linkText: 'Back to the homepage',
    link: '/',
  },
}
